module.exports = __webpack_public_path__ + "img/texture-brick-3-top.75509575.jpg";